import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Mesto } from './../mesto/mesto';

@Component({
  selector: 'yt-mesto-modal-update',
  templateUrl: './mesto-modal-update.component.html'
})
export class MestoModalUpdateComponent extends BaseModalUpdateComponent<Mesto> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Mesto>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
